<template>
  <section class="document">
    <div class="container">
      <div v-for="item in expand.list"
           class="box_list">
        <div v-if="item.title"
             class="box_title">
          {{ item.title }}
          <a-space v-if="item.button" size="small"
                   class="box_button">
            <template v-for="v in item.button">
              <router-link v-if="v.router" class="button_n_2"
                           :to="v.router">
                {{ v.title }}
              </router-link>
              <a-button v-if="v.href" type="link" class="button_n_2"
                        :href="v.href" target="_blank">
                {{ v.title }}
              </a-button>
            </template>
          </a-space>
        </div>
        <div v-for="v in item.sub"
             class="box_sub">
          <div v-if="v.title"
               class="box_title">
            {{ v.title }}
            <a-space v-if="v.button" size="small"
                     class="box_button">
              <template v-for="vv in v.button">
                <router-link v-if="vv.router" class="button_n_2"
                             :to="vv.router">
                  {{ vv.title }}
                </router-link>
                <a-button v-if="vv.href" type="link" class="button_n_2"
                          :href="vv.href" target="_blank">
                  {{ vv.title }}
                </a-button>
              </template>
            </a-space>
          </div>
          <a-row>
            <a-col v-for="vv in v.content"
                   :xs="24" :md="12">
              <a-button type="link"
                        :href="vv.href" target="_blank">
                {{ vv.title }}
              </a-button>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'databaseDocument',
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            title: '产品文档',
            sub: [
              {
                title: '云原生智能运维平台SchedulX',
                button: [
                  {
                    title: '前往产品页',
                    router: $Enum.RouterEnum.ProductSchedulX
                  }
                ],
                content: [
                  {
                    title: 'test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1',
                    href: ''
                  },
                  {
                    title: 'test-2',
                    href: ''
                  },
                  {
                    title: 'test-3',
                    href: ''
                  }
                ]
              }
            ]
          },
          {
            title: '行业白皮书',
            sub: [
              {
                content: [
                  {
                    title: 'test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1',
                    href: ''
                  },
                  {
                    title: 'test-2',
                    href: ''
                  },
                  {
                    title: 'test-3',
                    href: ''
                  }
                ]
              }
            ]
          },
          {
            title: '开发者文档',
            button: [
              {
                title: '前往开源社区',
                href: '111'
              },
              {
                title: 'GitHub主页',
                href: '111'
              }
            ],
            sub: [
              {
                title: '基本规范',
                content: [
                  {
                    title: 'test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1',
                    href: ''
                  },
                  {
                    title: 'test-2',
                    href: ''
                  },
                  {
                    title: 'test-3',
                    href: ''
                  }
                ]
              },
              {
                title: '任务对接指南',
                content: [
                  {
                    title: 'test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1test-1',
                    href: ''
                  },
                  {
                    title: 'test-2',
                    href: ''
                  },
                  {
                    title: 'test-3',
                    href: ''
                  }
                ]
              }
            ]
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/database/';
@p: 70px;
@b: 1px solid #EDEEF5;

.document {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  background: @color_7;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0 auto;
  }
}

.box_list {
  overflow: hidden;
  position: relative;
  margin: 20px 0 0;
  background: @color_white;
  border: @b;
  border-radius: 5px;
  
  .box_title {
    overflow: hidden;
    position: relative;
    border-bottom: @b;
    
    .box_button {
      float: right;
      
      .button_n_2 {
        line-height: 38px !important;
        font-weight: normal !important;
        border: 1px solid @color_6 !important;
      }
    }
  }
  
  > .box_title {
    padding: 10px @p 10px 25px;
    .font(left, 40px, @color_12, @text_big, true);
    
    &::before {
      content: '';
      display: inline-block;
      margin: 0 22px 0 0;
      .bg('@{image}decorate.png', 22px, 20px, true);
      .transform(translateY(3px));
    }
  }
  
  .box_sub {
    position: relative;
    padding: 0 @p;
    
    > .box_title {
      padding: 10px 0;
      .font(left, 40px, @color_12, @text);
    }
  }
  
  .ant-row {
    padding: 10px 0;
    font-size: 0;
    
    .ant-btn {
      display: inline-block;
      max-width: 90%;
      padding: 0;
      
      &:deep(span) {
        display: block;
        width: 100%;
        color: @color_6;
        .ellipsis();
      }
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  @p: 20px;
  
  .box_list {
    .box_title {
      .font(left, 30px, @color_12, @text_big_mo, true);
      
      .box_button {
        float: none;
        margin-top: 10px;
      }
    }
    
    > .box_title {
      padding: 10px @p;
      
      &::before {
        margin: 0 15px 0 0;
      }
    }
    
    .box_sub {
      padding: 0 @p;
      
      > .box_title {
        .font(left, 30px, @color_12, @text_mo);
      }
    }
  }
}
</style>